var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimedBattery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#71778a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -734)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 30,
    transform: "translate(23 734)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-4142.165,3550.559h-7.343A1.529,1.529,0,0,1-4151,3549v-19.88a1.528,1.528,0,0,1,1.493-1.557h.741v-.3c0-.693.335-1.258.747-1.258h5.581c.413,0,.748.564.748,1.258v.3h.746a1.525,1.525,0,0,1,1.487,1.557v11.241A8,8,0,0,0-4143,3547a7.91,7.91,0,0,0,.835,3.557Zm-4.342-10.05h0l-.583,4.5a.416.416,0,0,0,.255.443.356.356,0,0,0,.135.026.347.347,0,0,0,.09-.01.389.389,0,0,0,.243-.179l4.709-7.638a.429.429,0,0,0-.008-.463.391.391,0,0,0-.324-.176.421.421,0,0,0-.089.01l-1.658.4.459-4.478a.416.416,0,0,0-.264-.434.4.4,0,0,0-.13-.023.39.39,0,0,0-.334.193l-4.568,7.6a.427.427,0,0,0,.013.46.392.392,0,0,0,.322.174.369.369,0,0,0,.088-.011l1.642-.4Z",
    transform: "translate(4176 -2791)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.555 748.902)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7,14a7,7,0,1,1,7-7A7.008,7.008,0,0,1,7,14ZM6.846,7.894h0A.614.614,0,0,0,7,7.914h4.87a.609.609,0,1,0,0-1.218H7.305V2.435a.609.609,0,0,0-1.218,0V7.3a.609.609,0,0,0,.608.608.645.645,0,0,0,.15-.019Z",
    transform: "translate(0.445 0.098)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimedBattery);
export default __webpack_public_path__ + "static/media/timed_battery.ee265a400088b8f7a3f663b043192368.svg";
export { ForwardRef as ReactComponent };